module.exports = require("@ember/object/evented");